import { BFLType } from "../../types/DBTables";
import { IGlobalData } from "../../types/globalData";
import { IBIMHandler } from "./bimHandler";
import { IModuleRound, IRoundHandler } from "../roundHandler";
import { IModuleVattenburetSekundärsystem } from "../../types/ModuleDatas";
import { bfv_J9 } from "./BFV_J9";
import { IBFModule, IBFResult, IKontrollResultRow } from "../../types/BFL/Funktionskontroll";

import bflHelper from "./bflHelper";
import { logAndNotifyError } from "../logger";
import { bfv_J6 } from "./BFV_J6";

//todo -> make class?!
export const bfv_J5 = (): IBFModule => {
  const bfName = BFLType.BFV_J5;
  const getResult = (module: IModuleRound, bimHandler: IBIMHandler, roundHandler: IRoundHandler, globalData: IGlobalData): IBFResult => {
    let funktionsKontroller: IKontrollResultRow[] = [];
    let dbg = {} as any;
    let error: any = undefined;

    const bH = bflHelper.bflHelper();

    try {
      const moduleData: IModuleVattenburetSekundärsystem = module.data;

      const B7_Utstyrning_värmeventil = moduleData.varmeventilUtstyrning || (0 as number);
      const B14_VillkorUppfyllda = !B7_Utstyrning_värmeventil;
      const B4_ÄrVärde = (moduleData.framledningArvarde || 0) as number;
      const B6_BörVärde = (moduleData.framledningBorvarde || 0) as number;
      const B5_Diff_ÄrBör = B4_ÄrVärde - B6_BörVärde;
      //const B7_UtstyrningVärmeVentil = moduleData.varmeventilUtstyrning as number;
      const B8_ÅrligEnergiTransmission = bimHandler.BIM_ÅrligBruttoTransmission();

      const B9_ShuntensSystemAndel = moduleData.värmeSystemandel / 100;

      const bfv_j9 = bfv_J9().getResult(module, bimHandler, roundHandler, globalData);
      const B10_SchablonVärme = bfv_j9.data.schablonBesparing;

      //const B11_Värmekälla = bimHandler.energiKälla;
      const B12_Vägledande_Verkningsgrad = bimHandler.BIM_Vägledande_VerkninsgradAktuellVärmekälla;

      //B13 : =OM(B5>=1,5;B5/3*((B8*B9*B10)/B12);0)
      const B13_OverKonsumtion_Brutto =
        B5_Diff_ÄrBör >= 1.5 && B12_Vägledande_Verkningsgrad !== undefined
          ? (B5_Diff_ÄrBör / 3) * ((B8_ÅrligEnergiTransmission * B9_ShuntensSystemAndel * B10_SchablonVärme) / B12_Vägledande_Verkningsgrad)
          : 0.0;

      const D8_OverKonsumtion_Netto = B13_OverKonsumtion_Brutto / B12_Vägledande_Verkningsgrad;

      //Energislag
      //E17 : =LETARAD($B$11;'Grunddata IN'!$K$44:$M$54;3;FALSKT), B11 : ='Grunddata IN'!B15
      const energiSlag = bimHandler.energiSlag;

      dbg["Tabell 1"] = {
        B7_Utstyrning_värmeventil,
        B14_VillkorUppfyllda,
        B4_ÄrVärde,
        B6_BörVärde,
        B5_Diff_ÄrBör,
        B8_ÅrligEnergiTransmission,
        B9_ShuntensSystemAndel,
        B10_SchablonVärme,
        B12_Vägledande_Verkningsgrad,
        B13_OverKonsumtion_Brutto,
        D8_OverKonsumtion_Netto,
      };

      //Rule 3:
      // C19 : =OM(B14=0;1;0)
      const c19_ventil_stängd = !B14_VillkorUppfyllda;
      if (c19_ventil_stängd) {
        funktionsKontroller = [roundHandler.getFunktionsKontroll(bfName, 3, undefined, "")];
      }

      //Rule 2:
      // =IF(AND(B14=1;B13=0);1;0)
      const c18_No_Remark = B14_VillkorUppfyllda && B13_OverKonsumtion_Brutto === 0 ? true : false;
      if (c18_No_Remark) {
        funktionsKontroller = [roundHandler.getFunktionsKontroll(bfName, 2, D8_OverKonsumtion_Netto, energiSlag)];
      }

      //Rule 1
      // C21 : =IF(AND(B14=1;D21>1);1;0)
      const showOverKonsumtion = B14_VillkorUppfyllda && B13_OverKonsumtion_Brutto > 1 ? true : false;
      if (showOverKonsumtion) {
        funktionsKontroller = [roundHandler.getFunktionsKontroll(bfName, 1, D8_OverKonsumtion_Netto, energiSlag)];
      }

      const bfvJ6 = bfv_J6().getResult(module, bimHandler, roundHandler, globalData);
      if (!bfvJ6.data?.ingenGemensamYta) {
        for (let i = 0; i < bfvJ6.funktionsKontroller.length; i++) {
          bfvJ6.funktionsKontroller[i].OverrideBFName = BFLType.BFV_J6;
          funktionsKontroller.push(bfvJ6.funktionsKontroller[i]);
        }
        for (let n in bfvJ6.debug) {
          dbg["j6" + n] = bfvJ6.debug[n];
        }
      }

      if (bfvJ6.error) {
        error = "j6 error: " + bfvJ6.error;
      }
    } catch (ex: any) {
      logAndNotifyError(ex);
      error = ex.toString();
    }

    return {
      bfName: BFLType.BFV_J5,
      funktionsKontroller: bH.cleanFunktionsKontroller(funktionsKontroller),
      driftOptimeringar: [],
      note: "",
      error: error,
      debug: dbg,
    };
  };

  return { getResult, bfName };
};

const dflt = { bfv_J5 };

export default dflt;
